import type { ReactNode } from "react";
import { useParams } from "react-router-dom";

import { useCanEditSystem } from "./use-can-edit-system";

interface SystemEditGuardProps {
  children: ReactNode;
  message?: string;
}

export function SystemEditGuard({ children, message }: SystemEditGuardProps) {
  const { systemId } = useParams<{ systemId: string }>();
  const { canEdit, isLoading } = useCanEditSystem(systemId);

  if (isLoading) {
    return (
      <div role="status" aria-label="Checking access" className="flex min-h-screen w-full items-center justify-center">
        <span className="text-muted-foreground text-sm">Checking access…</span>
      </div>
    );
  }

  if (!canEdit) {
    return (
      <div role="alert" className="flex min-h-screen w-full flex-col items-center justify-center gap-2 text-center">
        <p className="text-foreground text-sm font-medium">
          {message ?? "You do not have edit access to this system."}
        </p>
        <p className="text-muted-foreground text-sm">Ask a system owner or editor for access.</p>
      </div>
    );
  }

  return <>{children}</>;
}
